import { Row, Space, Button, Flex } from "antd";
import cx from "classnames";
// import { Button } from "components/elements";
import { toJpeg, toPng } from 'html-to-image';
import { jsPDF } from 'jspdf';
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styles from "../styles/CompanyProfile.module.css";
import CompanyTreeOrganizationView from "./CompanyTreeOrganization";
import CompanyTreeOrganizationOverView from "./CompanyTreeOrganizationOverView";
import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg"
import { ReactComponent as ImportIcon } from "../../../assets/icon/importIcon.svg";

const CompanyOrganizationView = ({
  departmentList = [],
  companyInformation = {},
  onCancel = () => { },
  onEdit = () => { },
  getOrganization = () => { },
  handleOpenLevelModal = () => { },
  lang = "",
}) => {
  const { t } = useTranslation();
  console.log("departmentList", departmentList);
  const containerRef = useRef(null);
  const { roles } = useSelector((state) => state.company);
  const [isLoading, setIsLoading] = useState(false);

  const exportAndSaveImage = (chart) => {
    if (chart) {
      chart
        // .nodeHeight((d) => 50 + 25)
        // .nodeWidth((d) => 300 + 2)
        // .scaleExtent([0.5, 2])
        // .compact?.(false).render().fit().render()
        .exportImg({ full: true });
      // Re-render the chart before exporting
      // chart.exportImg({ full: true });
    }
  };
  const downloadImage = async () => {
    // console.log("containerRef", containerRef);
    //   ?.exportImg?.({ full: false })
    const chartElement = document.getElementById('apexTreeWrapper');

    // ตรวจสอบว่า chartElement ไม่ใช่ null ก่อน
    if (!chartElement) {
      console.error('Element with id "apexTreeWrapper" not found');
      return; // หยุดการทำงานของฟังก์ชันถ้าไม่พบองค์ประกอบ
    }
    // Temporarily expand the div to capture all content
    const originalWidth = chartElement.style.width;
    const originalHeight = chartElement.style.height;

    chartElement.style.width = `${chartElement.scrollWidth}px`;
    chartElement.style.height = `${chartElement.scrollHeight}px`;

    const scale = 10; // Increase resolution (optional)

    toJpeg(chartElement, {
      width: chartElement.scrollWidth * scale,
      height: chartElement.scrollHeight * scale,
      backgroundColor: "white",
      style: {
        transform: `scale(${scale})`,
        transformOrigin: 'top left',
        width: `${chartElement.scrollWidth}px`,
        height: `${chartElement.scrollHeight}px`,
      },
    })
      .then((dataUrl) => {
        // Reset styles
        chartElement.style.width = originalWidth;
        chartElement.style.height = originalHeight;

        // Trigger download
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = 'organizational-chart.png';
        link.click();
      })
      .catch((error) => {
        console.error('Could not generate image', error);
      });


  };

  // const downloadPDF = () => {
  //   const chartElement = document.getElementById('chart');

  //   htmlToImage.toPng(chartElement)
  //     .then((dataUrl) => {
  //       const pdf = new jsPDF();
  //       pdf.addImage(dataUrl, 'PNG', 0, 0);
  //       pdf.save('organizational-chart.pdf');
  //     })
  //     .catch((error) => {
  //       console.error('Could not generate PDF', error);
  //     });
  // };

  // const pagetree = CompanyTreeOrganizationOverView(departmentList,
  //   companyInformation,
  //   lang,
  //   containerRef)
  // <CompanyTreeOrganizationOverView
  //           departmentList={departmentList}
  //           companyInformation={companyInformation}
  //           lang={lang}
  //           graphRef={containerRef}
  //         />

  return (
    <>
      {getOrganization()}
      <Space
        className={styles.container}
        direction="vertical"
        size={24}
        style={{ overflow: "auto", width: '100%' }}
      >
        <Row justify="space-between" className={styles.container}>
          <Space size={20}>
            <Button
              onClick={() => {
                handleOpenLevelModal(true);
              }}
              // className={styles.buttom}
              style={{ width: "max-content", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: "white" }}
            >
              {t("organization_level.header")}
            </Button>
          </Space>
          <Space size={12}>
            <Button type="default"
              onClick={async () => {
                setIsLoading(true);
                try {
                  const res = await containerRef?.current?.compact?.(false).render().fit().render();
                  if (res) {
                    await new Promise((resolve) => setTimeout(resolve, 3000));
                    await downloadImage();
                  }
                } catch (err) {
                  console.error("Download error", err);
                } finally {
                  setIsLoading(false);
                }
              }}
              style={{ width: "max-content", height: "44px", color: "#42526D", padding: "8px 16px", borderRadius: "8px" }}
              loading={isLoading}
              disabled={isLoading}
            >
              {t("common.download")}
            </Button>
            {/* <Button type="default" onClick={onCancel} style={{ width: "max-content", height: "44px", color: "#42526D", padding: "8px 16px", borderRadius: "8px" }}>
              <Flex align="center" justify="center" gap={8}>
                <ImportIcon />
                <span>{t('common.import')}</span>
              </Flex>
            </Button> */}
            {
              (roles.includes("UPDATE_CONFIGURATION|COMPANY_SETTING|ORGANIZATION") || roles.includes("CREATE_CONFIGURATION|COMPANY_SETTING|ORGANIZATION")) &&
              <Button type="primary" onClick={onEdit} style={{ width: "max-content", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: "white" }}>
                <Flex align="center" justify="center" gap={8}>
                  <EditIcon />
                  {t("common.edit").toUpperCase()}
                </Flex>
              </Button>
            }

          </Space>
        </Row>

        <div className={cx(styles.card)} style={{
          // padding: "10px",
          // position: "relative",
          width: "100%",
          overflow: "auto",
          background: "white"
          // transformOrigin: "top left",
          // transition: "transform 0.3s ease",
          // transform: scale(1.2)
        }}>
          {/* {pagetree.page()} */}
          {/* <Layout> */}
          <CompanyTreeOrganizationView
            departmentList={departmentList}
            companyInformation={companyInformation}
            lang={lang}
            graphRef={containerRef}
          />
          {/* <CompanyTreeOrganizationOverView
            departmentList={departmentList}
            companyInformation={companyInformation}
            lang={lang}
            graphRef={containerRef}
          /> */}

          {/* </Layout> */}
        </div>
      </Space >
    </>
  );
};

export default CompanyOrganizationView;
